export const POLICY_CITY_WIDTH = 960
export const POLICY_CITY_HEIGHT = 640
export const POLICY_CITY_DEPARTMENT_LIMIT = 100
export const POLICY_BUILDINGS = [
  { value: 'AUTO', label: '自动匹配' }, { value: 'GOVERNMENT', label: '政务办公楼' },
  { value: 'HEALTH', label: '医疗服务中心' }, { value: 'EDUCATION', label: '教育服务中心' },
  { value: 'OFFICE', label: '综合办公楼' }, { value: 'SERVICE', label: '社区服务中心' }, { value: 'PARK', label: '园林服务站' }
]
export const validPolicyMapPoint = point => !!point && typeof point.x === 'number' && typeof point.y === 'number' && Number.isFinite(point.x) && Number.isFinite(point.y) && point.x >= 0 && point.x <= 100 && point.y >= 0 && point.y <= 100
const hash = text => [...String(text)].reduce((n, c) => (n * 31 + c.codePointAt(0)) >>> 0, 7)

export function policyCityPlan (count = 0) {
  const capacity = count <= 12 ? 12 : Math.ceil(count * 1.15)
  const cols = Math.max(4, Math.ceil(Math.sqrt(capacity * 4 / 3))), rows = Math.max(3, Math.ceil(capacity / cols))
  const width = cols * 240, height = rows * (POLICY_CITY_HEIGHT / 3)
  const blocks = Array.from({ length: cols * rows }, (_, i) => ({ col: i % cols, row: Math.floor(i / cols), x: i % cols * 240, y: Math.floor(i / cols) * height / rows, width: 240, height: height / rows }))
  return { cols, rows, width, height, blocks }
}

// Missing coordinates are a display fallback. Reading an old case never rewrites it.
export function policyCityDepartments (departments = []) {
  const plan = policyCityPlan(departments.length)
  const slots = plan.blocks.map(b => ({ x: (b.x + b.width / 2) / plan.width * 100, y: (b.y + b.height / 2) / plan.height * 100 }))
  const locations = new Map(), occupied = new Set()
  for (const [i, d] of departments.entries()) if (validPolicyMapPoint(d.mapPoint)) {
    locations.set(i, { ...d.mapPoint })
    const closest = slots.map((p, j) => ({ j, distance: Math.hypot(p.x - d.mapPoint.x, p.y - d.mapPoint.y) })).sort((a, b) => a.distance - b.distance)[0]
    if (closest) occupied.add(closest.j)
  }
  departments.map((d, i) => ({ d, i })).sort((a, b) => String(a.d.id || a.i).localeCompare(String(b.d.id || b.i))).forEach(({ d, i }) => {
    if (locations.has(i)) return
    const start = hash(d.id || 'department-' + i) % slots.length
    const available = Array.from({ length: slots.length }, (_, n) => (start + n) % slots.length).filter(n => !occupied.has(n))
    const clearance = point => locations.size ? Math.min(...[...locations.values()].map(p => Math.hypot((point.x - p.x) * plan.width / 100, (point.y - p.y) * plan.height / 100))) : Infinity
    const index = available.find(n => clearance(slots[n]) >= 90) ?? available.sort((a, b) => clearance(slots[b]) - clearance(slots[a]))[0] ?? start
    occupied.add(index); locations.set(i, { ...slots[index] })
  })
  return departments.map((d, i) => ({ ...d, mapPoint: locations.get(i) }))
}

export function nextPolicyDepartmentPoint (departments = []) {
  const probe = { id: '__new_city_department__', name: '' }
  return policyCityDepartments([...policyCityDepartments(departments), probe]).slice(-1)[0].mapPoint
}

export function policyBuildingStyle (department) {
  if (department.buildingStyle && department.buildingStyle !== 'AUTO' && POLICY_BUILDINGS.some(b => b.value === department.buildingStyle)) return department.buildingStyle
  const name = String(department.name || '')
  if (/卫健|卫生健康|医|医院|康复|保健/.test(name)) return 'HEALTH'
  if (/教育|学校|大学|幼儿/.test(name)) return 'EDUCATION'
  if (/园林|绿化|生态|林业/.test(name)) return 'PARK'
  if (/政务|政府|公安|消防|委员会/.test(name)) return 'GOVERNMENT'
  if (/社区|民政|服务|残联|街道/.test(name)) return 'SERVICE'
  return 'OFFICE'
}
